export default "__VITE_ASSET__e9e15a55__"